export default __webpack_public_path__ + "static/media/img_blog05.e0eba4df.jpg";